export const HEADER_CONSTANT = {
  profileMenu: [
    {
      name: 'Profile',
      src: 'assets/profile-icon.svg',
      alt: 'profile',
      link: '/dashboard/profile',
    },
    {
      name: 'My Bank Accounts',
      src: 'assets/bank-icon.svg',
      alt: 'myBankAccount',
      link: '/dashboard/bank-account-list',
    },
    {
      name: 'My Brands',
      src: 'assets/cards-icon.svg',
      alt: 'brands',
      link: '/dashboard/brand-list',
    },
    {
      name: 'My Categories',
      src: 'assets/benficiaries-icon.svg',
      alt: 'categories',
      link: '/dashboard/category-list',
    },
    {
      name: 'Payment Templates',
      src: 'assets/payment-icon.svg',
      alt: 'paymentTemplates',
      link: '/dashboard/payment-list',
    },
    {
      name: 'Contacts',
      src: 'assets/contact-icon.svg',
      alt: 'contacts',
      link: '/dashboard/contacts',
    },
    {
      name: 'Support',
      src: 'assets/support-icon.svg',
      alt: 'support',
      link: '/dashboard/support',
    },
  ],
} as const;
